export const yesNoDropdownItems = [{ text: 'Nee', value: false }, { text: 'Ja', value: true }]
